"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDateTypeFormatIndexes = exports.getDateTypeFormatForLocale = exports.DateTypeFormat = exports.formatsByLocale = void 0;
// List of Locales and the Date format they correspond to. Copied from : https://wiki.indeed.com/pages/viewpage.action?spaceKey=localization&title=International+Number+Formatting+Rules
exports.formatsByLocale = {
    DD_MM_YYYY: [
        'en-AE',
        'en-AU',
        'en-IE',
        'en-IN',
        'en-NZ',
        'en-SG',
        'es-CL',
        'nl',
        'nl-NL',
        'pt-PT',
        'da',
        'da-DK',
        'de',
        'de-AT',
        'de-BE',
        'de-CH',
        'de-DE',
        'de-LU',
        'en-BE',
        'en-CH',
        'en-IL',
        'en-LU',
        'fi',
        'fi-FI',
        'fr-BE',
        'fr-CH',
        'fr-LU',
        'he',
        'he-IL',
        'it-CH',
        'nl-BE',
        'no',
        'no-NO',
        'pl',
        'ro',
        'ro-RO',
        'ru-UA',
        'ru-RU',
        'tr',
        'uk-UA',
        'ar',
        'ar-SA',
        'ar-EG',
        'el',
        'el-GR',
        'en-BH',
        'en-EG',
        'en-GB',
        'en-HK',
        'en-KW',
        'en-NG',
        'en-OM',
        'en-QA',
        'en-SA',
        'en-TH',
        'es-AR',
        'es-CO',
        'es-CR',
        'es-EC',
        'es-ES',
        'es-MX',
        'es-PA',
        'es-PE',
        'es-UY',
        'es-VE',
        'fr-FR',
        'fr-MA',
        'en-MA',
        'in',
        'it',
        'ms',
        'pt-BR',
        'th'
    ],
    MM_DD_YYYY: ['en-ID', 'en-MY', 'en-PH', 'en-US'],
    YYYY_MM_DD: [
        'en-CA',
        'en-VN',
        'en-ZA',
        'fr-CA',
        'sv',
        'sv-SE',
        'vi',
        'ko',
        'hu',
        'hu-HU',
        'ja',
        'zh-HK',
        'zh-SG',
        'zh-TW'
    ]
};
var DateTypeFormat;
(function (DateTypeFormat) {
    DateTypeFormat["DD_MM_YYYY"] = "DD_MM_YYYY";
    DateTypeFormat["MM_DD_YYYY"] = "MM_DD_YYYY";
    DateTypeFormat["YYYY_MM_DD"] = "YYYY_MM_DD";
})(DateTypeFormat = exports.DateTypeFormat || (exports.DateTypeFormat = {}));
/*
 * Gets the DateTypeFormat for a given locale
 */
exports.getDateTypeFormatForLocale = (localeStr) => {
    localeStr = localeStr.replace('_', '-');
    if (exports.formatsByLocale.MM_DD_YYYY.includes(localeStr)) {
        return DateTypeFormat.MM_DD_YYYY;
    }
    else if (exports.formatsByLocale.YYYY_MM_DD.includes(localeStr)) {
        return DateTypeFormat.YYYY_MM_DD;
    }
    else if (exports.formatsByLocale.DD_MM_YYYY.includes(localeStr)) {
        return DateTypeFormat.DD_MM_YYYY;
    }
    else {
        return DateTypeFormat.DD_MM_YYYY;
    }
};
/**
 * Get the index of siginficant digits for the given format
 *
 * @param dateType
 */
exports.getDateTypeFormatIndexes = (dateType) => {
    switch (dateType) {
        case DateTypeFormat.MM_DD_YYYY:
            return {
                dateType: DateTypeFormat.MM_DD_YYYY,
                dayIndex: 1,
                monthIndex: 0,
                yearIndex: 2
            };
        case DateTypeFormat.YYYY_MM_DD:
            return {
                dateType: DateTypeFormat.YYYY_MM_DD,
                dayIndex: 2,
                monthIndex: 1,
                yearIndex: 0
            };
        case DateTypeFormat.DD_MM_YYYY:
            return {
                dateType: DateTypeFormat.DD_MM_YYYY,
                dayIndex: 0,
                monthIndex: 1,
                yearIndex: 2
            };
    }
};
//# sourceMappingURL=data:application/json;base64,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